import { Dialog, Transition } from '@headlessui/react';
import classNames from 'classnames';
import React, { Fragment } from 'react';
const Modal = ({
  children,
  isOpen,
  setOpen,
  containerClassName,
  childContainerClassName,
  showOverlay
}) => {
  const parentContainer = classNames('flex', 'items-center', 'justify-center', 'min-h-screen', 'sm:block', 'sm:px-0', 'text-center', `${containerClassName ?? ''}`);
  const childContainer = classNames('bg-white', 'inline-block', 'overflow-hidden', 'pb-4', 'pt-5', 'px-4', 'relative', 'min-h-[37rem]', 'rounded-xl', 'shadow-xl', 'sm:w-full', 'sm:align-middle', 'sm:max-w-xl', 'sm:my-8', 'sm:p-6', 'text-left', 'transform', 'transition-all', `${childContainerClassName ?? ''}`);
  const overlayClassnames = classNames('fixed', 'inset-0', 'transition-opacity', {
    'bg-black bg-opacity-75': showOverlay
  });
  return /*#__PURE__*/React.createElement(Transition.Root, {
    show: isOpen,
    as: Fragment
  }, /*#__PURE__*/React.createElement(Dialog, {
    as: "div",
    className: "fixed inset-0 z-10 overflow-y-auto",
    onClose: () => setOpen(false)
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "modal",
    className: parentContainer
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement(Dialog.Overlay, {
    className: overlayClassnames
  })), /*#__PURE__*/React.createElement("span", {
    className: "hidden sm:inline-block sm:h-screen sm:align-middle",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
    enterTo: "opacity-100 translate-y-0 sm:scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  }, /*#__PURE__*/React.createElement("div", {
    className: childContainer,
    "data-testid": "confirmationModal"
  }, children)))));
};
export default Modal;